<template>
  <ul class="icon-count-list">
    <li v-for="(item, index) in chartData" :key="index">
      <div class="icon">
        <img :src="item.icon" />
      </div>
      <div class="name">{{ item.name }}</div>
      <div class="count">{{ item.count }}</div>
      <div class="unit">{{ item.unit }}</div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "IconCountList",
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
ul {
  li {
    width: 50%;
    height: 0.3rem;
    line-height: 0.3rem;
    float: left;
    padding-left: 0.1rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    > div {
      float: left;
    }
    .icon {
      width: 0.3rem;
      height: 0.3rem;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .count {
      font-size: 0.21rem;
      font-weight: bold;
      color: #00cdff;
      margin: 0 0.07rem;
    }
  }
}
</style>
